module.exports = __webpack_public_path__ + "4b3916bd9b3122f4471da6826e2200da.png";